export const getPriceByCurrency = (prices: any, currency: any) => {
  const price = prices?.find(
    (item: any) => item.currency.toLowerCase() === currency.toLowerCase(),
  );
  return price ? price.amount : null;
};
